<template>
  <div>
    <div class="offers" v-if="!currentPOI">

      <div class="wf-component wf-poi-advertisements">
        <div v-for="ad in poiAdvertisements" :key="ad.id" @click="adClick(ad)">
          <WFPOIAdvertisement :ad="ad" @click="adClick(ad)"></WFPOIAdvertisement>
        </div>

      </div>

    </div>
    <div v-if="currentPOI">
      <SinglePOI :currentPOI="currentPOI" :setCurrentPOI="backFromPOI"></SinglePOI>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex';
import SinglePOI from "@/components/SinglePOI";

export default {
    computed: {
		...mapState('wf', ['language', 'poiAdvertisements', 'pois']),
	},
  components: {
    SinglePOI,
  },
  data() {
    return {
      currentPOI: null,
    }
  },
  methods: {
    adClick({poi_id}) {
      if (poi_id) {
        for (const poi of this.pois) {
          if (poi.id == poi_id) {
            this.$store.dispatch('setPOI', poi);
            this.currentPOI = poi;
            this.$wayfinder.statistics.onClick(poi.id, "menu");
          }
        }
      }
    },
    backFromPOI() {
      this.currentPOI = null;
    }
  }
}
</script>
